import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Form, Input, message } from 'antd';
import { userActions } from '../../../../actions/user.actions';
import DispexButton from '../../../../components/DispexButton/DispexButton';
import getConsentText from '../../requests/getConsentText';

const placeholderConsentText = `Я, действуя свободно, своей волей и в своем интересе, информировано и конкретно, даю свое согласие ООО «Диспэкс» (ИНН 7203425202, ОГРН 1177232021570) на обработку моих персональных данных.Для использования данного приложения необходимо ознакомиться с положениями и условиями, указанными в перечисленных ниже документах:\n Пользовательское соглашение \n Политика конфиденциальности`;

function ConsentText({
  consentText,
  linkUserAgreement,
  linkPrivacyPolicy,
  linkAgreement,
}) {
  const formatted = consentText
    .replace(
      /“Пользовательское соглашение”/,
      `<a href="${linkUserAgreement}" target="_blank" rel="noopener noreferrer">"Пользовательское соглашение"</a>`
    )
    .replace(
      /“Политика конфиденциальности”/,
      `<a href="${linkPrivacyPolicy}" target="_blank" rel="noopener noreferrer">"Политика конфиденциальности"</a>`
    )
    .replace(
      /“согласие”/,
      `<a href="${linkAgreement}" target="_blank" rel="noopener noreferrer">"согласие"</a>`
    );

  return <span dangerouslySetInnerHTML={{ __html: formatted }} />;
}

const LoginForm = ({
  setForgotPasswordModalOpened,
  username,
  setUsername,
  password,
  setPassword,
  setStep,
}) => {
  const dispatch = useDispatch();
  const loginRef = useRef();
  const passwordRef = useRef();
  const [thereIsNoUsername, setThereIsNoUsername] = useState(false);
  const [thereIsNoPassword, setThereIsNoPassword] = useState(false);
  const [userInteraction, setUserInteraction] = useState(false);
  const [userTryingToFillUsername, setUserTryingToFillUsername] =
    useState(false);
  const [userTryingToFillPassword, setUserTryingToFillPassword] =
    useState(false);
  const alert = useSelector((store) => store.alert);
  useEffect(() => {
    if (alert.message) {
      message.error(alert.message);
    }
  }, [alert]);
  const onUserChange = useCallback(
    (e) => {
      setUsername(e.target.value);
      setThereIsNoUsername(!e.target.value);
    },
    [setUsername]
  );
  const onPasswordChange = useCallback(
    (e) => {
      setPassword(e.target.value);
      setThereIsNoPassword(!e.target.value);
    },
    [setPassword]
  );
  const openForgotPasswordPopup = useCallback(
    () => setForgotPasswordModalOpened(true),
    [setForgotPasswordModalOpened]
  );
  const onEnter = useCallback(() => {
    setThereIsNoUsername(!username);
    setThereIsNoPassword(!password);
    if (password && username) {
      dispatch(
        userActions.authenticateWithCheckTwofact(username, password, setStep)
      );
      // dispatch(userActions.login(username, password));
    }
  }, [username, password, dispatch, setStep]);

  useEffect(() => {
    setTimeout(() => {
      const autofilled = document.querySelectorAll(':-webkit-autofill');
      console.log(autofilled);
      window.autofilled = autofilled;
    });
  }, []);
  const listener = useCallback(() => setUserInteraction(true), []);
  useEffect(() => {
    window.addEventListener('click', listener, {
      once: true,
    });
    passwordRef.current.input.addEventListener('focus', listener, {
      once: true,
    });
    loginRef.current.input.addEventListener('focus', listener, {
      once: true,
    });
    return () => {
      window.removeEventListener('click', listener);
      loginRef.current.input.removeEventListener('focus', listener);
      passwordRef.current.input.removeEventListener('focus', listener);
    };
  }, [listener]);
  const onUsernameFocus = useCallback(
    () => setUserTryingToFillUsername(true),
    []
  );
  const onUsernameBlur = useCallback(
    () => setUserTryingToFillUsername(false),
    []
  );
  const onPasswordFocus = useCallback(
    () => setUserTryingToFillPassword(true),
    []
  );
  const onPasswordBlur = useCallback(
    () => setUserTryingToFillPassword(false),
    []
  );

  const [checked, setChecked] = useState(false);
  const [consentText, setConsentText] = useState('');

  const handleChecked = () => {
    setChecked((prev) => !prev);
  };

  useEffect(() => {
    const fetchConsentText = async () => {
      try {
        const text = await getConsentText();
        setConsentText(text || '');
      } catch (error) {
        console.error('Error fetching consent text:', error);
      }
    };

    fetchConsentText();
  }, []);

  return (
    <>
      <p className="login_page-main-title">Вход в аккаунт</p>
      <div className="login_page-main-form_container">
        <Form.Item
          className="field"
          style={{ width: '100%' }}
          label=""
          colon={false}
          validateStatus={
            thereIsNoUsername && !userTryingToFillUsername ? 'error' : ''
          }
          help={
            thereIsNoUsername && !userTryingToFillUsername
              ? 'Пожалуйста, введите логин'
              : ' '
          }
        >
          <Input
            onFocus={onUsernameFocus}
            onBlur={onUsernameBlur}
            ref={loginRef}
            className="input"
            placeholder="Логин"
            value={username}
            onChange={onUserChange}
          />
        </Form.Item>
        <Form.Item
          className="field"
          label=""
          colon={false}
          validateStatus={
            thereIsNoPassword && !userTryingToFillPassword ? 'error' : ''
          }
          help={
            thereIsNoPassword && !userTryingToFillPassword
              ? 'Пожалуйста, введите пароль'
              : ' '
          }
        >
          <Input.Password
            onFocus={onPasswordFocus}
            onBlur={onPasswordBlur}
            className="password_input"
            placeholder="Пароль"
            ref={passwordRef}
            value={password}
            onChange={onPasswordChange}
          />
        </Form.Item>
        <div
          type="link"
          className="login_page-main-forgot_password"
          onClick={openForgotPasswordPopup}
        >
          Не помню пароль
        </div>
        <div className="agreement">
          <Checkbox
            checked={checked}
            onChange={handleChecked}
          >
            {consentText && consentText.consentText ? (
              <ConsentText
                consentText={consentText.consentText}
                linkUserAgreement={consentText.linkUserAgreement}
                linkPrivacyPolicy={consentText.linkPrivacyPolicy}
                linkAgreement={consentText.linkAgreement}
              />
            ) : (
              <span>{placeholderConsentText}</span>
            )}
          </Checkbox>
        </div>
        <DispexButton
          htmlType="submit"
          type="primary"
          className="login_page-main-entry_button"
          disabled={!checked || (userInteraction && (!username || !password))}
          onClick={onEnter}
        >
          Войти
        </DispexButton>
      </div>
    </>
  );
};

export default memo(LoginForm);
